import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { IdName } from './../../models/id-name.model';
import { ReportStatus } from './../../enums/report-status.enum';

@Pipe({
  name: 'reportStatus',
  standalone: false
})
export class ReportStatusPipe implements PipeTransform {
  public transform(value: ReportStatus): string {
    return getReportStatus(value);
  }
}

export function getReportStatus(value: ReportStatus): string {
  switch (value) {
    case ReportStatus.None:
      return '';
    case ReportStatus.New:
      return 'New';
    case ReportStatus.Updated:
      return 'Updated';
    case ReportStatus.ComingSoon:
      return 'Coming Soon';
    default:
      throw new Error(`Unsupported value for ReportStatus: ${value}.`);
  }
}

export function getReportStatusList(): IdName[] {
  return enumToList(ReportStatus, getReportStatus);
}
